module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/fonts/roboto/Roboto-Bold.woff
 ** module id = 437
 ** module chunks = 0
 **/